import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { GeneralSettings } from '../../../../shared/settings/general';

/**
 * Fetches the general settings for an organization.
 * This hook provides automatic caching and request deduplication.
 * For read-only access to general settings, prefer this hook over useGeneralSettings.
 */
export function useOrganizationLicenseConcludedSetting(organizationId: number, shouldFetch: boolean = true) {
  return useQuery({
    queryKey: ['organization', organizationId, 'settings', 'general'],
    queryFn: () => get<GeneralSettings>(`/api/organizations/${organizationId}/settings/general/license-concluded`),
    enabled: shouldFetch,
  });
}
